import AuthService from '../../utilities/services/auth.service'

import { SalesReceivablesByCategoryWrapper } from '../../components'

export default function SalesReceivablesByCategoryPage() {
  const organization = AuthService.getOrg()[0]

  return <SalesReceivablesByCategoryWrapper organization={organization} />
}
